import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import {round} from '../../../../utils/func';
import ImgBlock from './Image';

class Block extends React.Component {

  state = {
    totalPrice: 0
  };

  componentDidMount() {
    this.calcResult()
  }

  static propTypes = {
    id: PropTypes.number,
    tourPhotos: PropTypes.array,
    title: PropTypes.string,
    tourDates: PropTypes.array,
    metingPlace: PropTypes.object,
    selectedData: PropTypes.object,
    priceOnePerson: PropTypes.number,
    cities: PropTypes.array,
    vehicle: PropTypes.object,
    cityId: PropTypes.number,
    onTotalPrice: PropTypes.func,
  };

  getTime = () => {
    const {tourDates} = this.props;
    const {timeSlotId} = this.props.selectedData;
    for (let i = 0; i < tourDates.length; i++) {
      if (tourDates[i].id === timeSlotId) {
        return moment(tourDates[i].startTime, "HH:mm").locale('en').format('hh:mm A')
      }
    }
    return ''
  };

  getTransportationPrice = () => {
    const {vehicle, selectedData} = this.props;
    const {persons} = selectedData;
    const {prices} = vehicle;
    let result = 0;
    if (prices && prices.length > 0 && persons) {
      for (let i = 0; i < prices.length; i++) {
        if (persons >= prices[i].minPersons && persons <= prices[i].maxPersons) {
          result = prices[i].priceOnePerson;
          break;
        }
      }
      if (!result) {
        for (let i = 0; i < prices.length; i++) {
          if (result < prices[i].priceOnePerson) {
            result = prices[i].priceOnePerson;
          }
        }
        for (let i = 0; i < prices.length; i++) {
          if (result > prices[i].priceOnePerson) {
            result = prices[i].priceOnePerson;
          }
        }
      }
      return result;
    }
    return 0;
  };

  getStaffPrice = () => {
    const {cities, cityId} = this.props;
    if (cities && cities.length) {
      for (let i = 0; i < cities.length; i++) {
        if (cities[i].id === cityId) {
          return cities[i].staffPrice;
        }
      }
    }
    return 0;
  };

  calcResult = () => {
    const {persons, guide} = this.props.selectedData;
    const {priceOnePerson, id} = this.props;
    let result = (priceOnePerson * persons) + (persons * this.getTransportationPrice());
    if (guide) {
      result += this.getStaffPrice()
    }
    this.setState({totalPrice: round(result)});
    this.props.onTotalPrice({[id]: round(result)});
    return round(result);
  };

  render() {
    const {
      title,
      metingPlace,
      selectedData,
      priceOnePerson,
      tourPhotos,
    } = this.props;

    const {
      persons,
      guide
    } = selectedData;

    return (
      <li className="booking__item">
        <figure className="booking__item-header">
          <ImgBlock
            images={tourPhotos}
          />
          <figcaption className="booking__item-info">
            <p className="booking__item-title">{title}</p>
            {
              guide ?
                <p className="booking__item-status staff-yes">Staff included</p>
                :
                <p className="booking__item-status staff-no">No staff</p>
            }
          </figcaption>
        </figure>
        <div className="booking__address">
          <span className="booking__label">Pick up point:</span>
          <span className="booking__content">{metingPlace.address}</span>
        </div>
        <div className="booking__item-body">
          <div className="booking__item-block">
            <p className="booking__item-group">
              <span className="booking__label">Date </span>
              <span className="booking__content">{moment(selectedData.date).locale('en').format('DD MMMM YYYY')}</span>
            </p>
            <p className="booking__item-group">
              <span className="booking__label">Time </span>
              <span className="booking__content">{this.getTime()}</span>
            </p>
            <p className="booking__item-group">
              <span className="booking__label">Number of attendees </span>
              <span className="booking__content">{persons}</span>
            </p>
          </div>
          <div className="booking__item-block booking__price">
            <p className="booking__item-group">
              <span className="booking__label">Price/person</span>
              <span className="booking__content"><span>$</span>{round(priceOnePerson + this.getTransportationPrice(), 2)}</span>
            </p>
          </div>
        </div>
        <div className="booking__item-footer">
          <p className="booking__item-group">
            <span className="booking__label">Price</span>
            <span className="booking__content"><span>$</span>{this.state.totalPrice}</span>
          </p>
        </div>
      </li>
    )
  }
}

export default Block;


// WEBPACK FOOTER //
// ./src/app/containers/Booking/components/Block/index.js